import styled from 'styled-components'

export const TiptapWrapperUi = styled.div`
  .tippy-box {
    max-width: none !important;
    min-width: 258px
  }
`
